import React from "react";
import { CategoryTemplate } from "themes/application/categories/components";

function Category(props) {
    return <CategoryTemplate {...props} />;
}

export default Category;
